import { Button, FileInput } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import Common from "@utilities/common";
import { AiOutlineFileExcel } from "react-icons/ai";

const ExcelContainer = () => {
    const { mutate } = useMutation(
        ["getProductsExcel"],
        () => Common.api.products.GetExcel(),
        {
            onSuccess: ({ data }) => {
                // create file link in browser's memory
                const href = window.URL.createObjectURL(
                    new Blob([data as any], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    }),
                );

                // create "a" HTML element with href to file & click
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "file.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            },
        },
    );

    const { mutate: UploadExcel } = useMutation(
        ["getProductsExcel"],
        ({ file }: { file: File }) => Common.api.products.UploadExcel({ file }),
    );

    const handleGetProductsExcel = () => {
        mutate();
    };

    const handleUploadProductsExcel = (file: File) => {
        if (!file) return undefined;

        UploadExcel({ file });
    };

    return (
        <div>
            <h2 className="mb-2">دانلود اکسل ها</h2>
            <div className="grid grid-cols-4 items-center justify-center mb-16">
                <div>
                    <Button
                        fullWidth
                        className="flex justify-center items-center"
                        color="green"
                        onClick={handleGetProductsExcel}>
                        <div className="ml-2">همه محصولات</div>

                        <AiOutlineFileExcel className="text-lg" />
                    </Button>
                </div>
            </div>

            <h2 className="mb-2">آپلود اکسل ها</h2>
            <div className="grid grid-cols-4 items-center justify-center">
                <div>
                    <FileInput
                        accept=".xlsx"
                        label="بروزرسانی"
                        placeholder="بروزرسانی قیمت و موجودی"
                        onChange={handleUploadProductsExcel}
                    />
                </div>
            </div>
        </div>
    );
};

export default ExcelContainer;
